/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2019-04-30
 * Copyright All Rights Reserved
 */

export const INVALID_CREDENTIALS = 'Invalid email or password';
export const PROBLEM_WITH_REQUEST = 'There was a problem with your request';
export const SELECT_AT_LEAST_ONE_MODEL_TYPE = 'Select at least one model type';
export const USER_EMAIL_ALREADY_EXISTS = 'A user with this email address already exists';



// WEBPACK FOOTER //
// ./js/constants/errorMessages.js